var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageArrowUpRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 0H64C28.75 0 0 28.748 0 63.994V352C0 387.248 28.75 415.994 64 415.994H160V499.961C160 509.709 171.25 515.459 179.125 509.709L304 415.994H448C483.25 415.994 512 387.248 512 352V63.994C512 28.748 483.25 0 448 0ZM368 264C368 277.25 357.25 288 344 288S320 277.25 320 264V193.938L224 289.938C214.619 299.318 199.436 299.311 190.062 289.938C180.688 280.562 180.688 265.375 190.062 256L286.062 160H216C202.75 160 192 149.25 192 136S202.75 112 216 112H344C357.25 112 368 122.75 368 136V264Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageArrowUpRight);
export default __webpack_public_path__ + "static/media/message-arrow-up-right.c287dd1bd57c802eaae39d4c071e9809.svg";
export { ForwardRef as ReactComponent };